import { defineStore } from 'pinia'

export const useStore = defineStore('bucket', {

  state: () => ({
    modal: {
      id: String,
      category: String,
    },
    newsList: [],
    brandList: [],
    shopList: [],
    contactSession: [],
  }),

  getters: {
    getModalState() {
      return this.modal
    },
    getNewsList() {
      return this.newsList
    },
    getBrandList() {
      return this.brandList
    },
    getShopList() {
      return this.shopList
    },
    getContactSession(){
      return this.contactSession
    },
  },
  
  actions: {
    updateNewsList(_data) {
      this.newsList = _data
    },
    updateBrandList(_data) {
      this.brandList = _data
    },
    updateShopList(_data) {
      this.shopList = _data
    },
    updateModal(_data) {
      this.modal = _data
    },
    setContactSession (_data){
      this.contactSession = _data
    },
  },

})
